import {
  Datagrid,
  Filter,
  List,
  SearchInput,
  TextField,
  useRecordContext,
  Link,
  useCreatePath,
  ArrayField,
  ChipField,
  SingleFieldList,
} from 'react-admin'

import Pill from '../components/pill'
import moment from 'moment'

const AgListFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="copro_code" />
  </Filter>
)

const AgLastData = () => {
  const createPath = useCreatePath()
  const resource = useRecordContext()
  let status = 'error'
  if (
    moment(resource.ag_last_date).isBetween(
      moment().subtract(1, 'year'),
      new Date()
    )
  )
    status = 'success'

  return (
    <Pill
      status={status}
      value={
        !resource.ag_last_date ? (
          'N/A'
        ) : (
          <Link
            to={createPath({
              resource: 'ags1a',
              type: 'edit',
              id: resource.ag_last_copromatic_id,
            })}
            style={{
              all: 'unset',
              cursor: 'pointer',
              textAlign: 'center',
            }}
          >
            {moment(resource.ag_last_date).format('DD/MM/YYYY')}
          </Link>
        )
      }
    />
  )
}

const AgNextData = () => {
  const createPath = useCreatePath()
  const resource = useRecordContext()

  return (
    <Pill
      status={resource.ag_future_date ? 'success' : 'error'}
      value={
        !resource.ag_future_date ? (
          'N/A'
        ) : (
          <Link
            to={createPath({
              resource: 'ags1a',
              type: 'edit',
              id: resource.ag_future_copromatic_id,
            })}
            style={{
              all: 'unset',
              cursor: 'pointer',
              textAlign: 'center',
            }}
          >
            {moment(resource.ag_future_date).format('DD/MM/YYYY')}
          </Link>
        )
      }
    />
  )
}

const Statut = () => (
  <Pill
    style={{
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
      color: 'black',
    }}
    value="N/A"
  />
)

export const AgList = () => (
  <List
    exporter={false}
    hasCreate={false}
    perPage={100}
    filters={<AgListFilter />}
  >
    <Datagrid bulkActionButtons={false}>
      <TextField source="copro_code" />
      <AgLastData source="ag_last" />
      <AgNextData source="ag_next" />
      <Statut source="statut" />
      <ArrayField source="managers">
        <SingleFieldList>
          <ChipField source="fullname" size="small" />
        </SingleFieldList>
      </ArrayField>
    </Datagrid>
  </List>
)
